@if (rows.length) {
  <div class="grid-container">
    @if (canSearch) {
      <div class="search-container">
        <app-common-search [inputPlaceholder]="'Search'" (searchText)="onSearchText($event)" (clearSearch)="onClearSearch()"></app-common-search>
      </div>
    }
    <div class="grid-item-container">
      @for (row of filteredItems$; track row) {
        <div class="grid-item tag-name-ctnr">
          <div class="w-pct-100 flex p-6" [class.restricted-row]="!row.canSelect">
            @if (!row.canSelect) {
              <button type="button" class="accordion-toggle-btn" (click)="toggleRow(row)" aria-label="Toggle row details">
                <span class="accordion-toggle-icon" [ngClass]="{ 'is-expanded': row.isExpanded }" aria-hidden="true"></span>
              </button>
            }
            <mat-checkbox class="row-checkbox" [class.restricted-checkbox]="!row.canSelect" [disabled]="!row.canSelect" [(ngModel)]="row.isChecked" (ngModelChange)="update(row)">{{ row.value }}</mat-checkbox>
            @if (!row.canSelect) {
              <mat-icon
                class="action-icon alert"
                aria-hidden="false"
                matTooltipPosition="right"
                [matTooltip]="'Root tags cannot be deleted'"
              >warning</mat-icon>
            }
          </div>
          @if (row.isExpanded && row.points.length) {
            <div class="row-content">
              <div class="content-header">
                Non-Conforming Points
              </div>
              @for (point of row.points; track point) {
                <div class="content-item">
                  <span class="notranslate">{{point.name}}</span>
                </div>
              }
            </div>
          }
          @if (row.isExpanded && row.equips.length) {
            <div class="row-content">
              <div class="content-header" >
                Non-Conforming Equips  <mat-icon class="action-icon info" aria-hidden="false" matTooltip="Deleting these tags would result in the loss of uniqueness for below points:">info</mat-icon>
              </div>
              @for (equip of row.equips; track equip) {
                <div class="content-item">
                  <span class="notranslate">{{equip.name}}</span>
                </div>
              }
            </div>
          }
          @if (row.isExpanded && !row.equips.length && !row.points.length) {
            <div class="row-content">
              <div class="no-content">
                This tag has no conflicts and can be deleted
              </div>
            </div>
          }
        </div>
      }
      @if (!filteredItems$?.length) {
        <div class="no-result-message">No result found.</div>
      }
    </div>
  </div>
}
